const getAenderbarBisText = (aenderbarBisExpired: boolean, aenderbarBis = 'Datum unbekannt'): string => {
    return aenderbarBisExpired ? `Gesperrt seit ${aenderbarBis}` : `Änderbar bis ${aenderbarBis}`;
};

export { getAenderbarBisText };
